import React, { useEffect, useState } from 'react';
import { listTirages } from '../api/tirages';
import './LotterySearchModal.css';

// Ligne synthetique "toutes les loteries" — code 0. Les pages de filtre/rapport
// l'interpretent comme "pas de restriction de loterie". Masquee sur les pages de
// config (saisie d'un resultat, edition de limites d'UNE loterie) via allowAll={false}.
const ALL_ROW = { id: '__all__', code: 0, name: 'TOUS' };

const LotterySearchModal = ({ onSelect, onClose, allowAll = true }) => {
  const [query, setQuery] = useState('');
  const [allLotteries, setAllLotteries] = useState([]);
  const [results, setResults] = useState([]);

  useEffect(() => {
    let cancelled = false;
    listTirages()
      .then((data) => {
        if (cancelled) return;
        setAllLotteries(data);
        setResults(data);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  const handleSearch = () => {
    setResults(
      allLotteries.filter(l =>
        l.name.toLowerCase().includes(query.toLowerCase())
      )
    );
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleSearch();
  };

  return (
    <div className="lsm-overlay">
      <div className="lsm-modal">
        <div className="lsm-header">
          <button className="lsm-close-btn" onClick={onClose}></button>
        </div>

        <div className="lsm-body">
          <p className="lsm-search-by">Search By:</p>
          <div className="lsm-radio-row">
            <label className="lsm-radio-label">
              <input type="radio" name="searchBy" defaultChecked readOnly />
              Name
            </label>
            <input
              className="lsm-name-input"
              type="text"
              value={query}
              onChange={e => setQuery(e.target.value)}
              onKeyDown={handleKeyDown}
              autoFocus
            />
          </div>

          <div className="lsm-search-row">
            <input
              className="lsm-search-input"
              type="text"
              value={query}
              onChange={e => setQuery(e.target.value)}
              onKeyDown={handleKeyDown}
            />
            <button className="lsm-search-btn" onClick={handleSearch}>Search</button>
          </div>

          <div className="lsm-table-wrapper">
            <table className="lsm-table">
              <thead>
                <tr>
                  <th>Codigo</th>
                  <th>Nombre</th>
                </tr>
              </thead>
              <tbody>
                {(allowAll ? [ALL_ROW, ...results] : results).map((row) => (
                  <tr
                    key={row.id}
                    className="lsm-row"
                    onClick={() => { onSelect(row.code, row.name); onClose(); }}
                  >
                    <td>{row.code}</td>
                    <td>{row.name}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="lsm-footer">
          <button className="lsm-cancel-btn" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default LotterySearchModal;
